import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

interface IPurchaseLayoutProps {
  title: string;
  list: React.ReactNode;
}

import * as styles from './style.css';
import { Layout } from '../../../../components/Layout';

export function PurchaseLayout({ title, list }: IPurchaseLayoutProps) {
  return (
    <section className={styles['container']}>
      <Layout>
        <div className={styles['wrapper']}>
          <div className={styles['title']}>
            <UIHeading1>{title}</UIHeading1>
          </div>
          {list}
        </div>
      </Layout>
    </section>
  );
}
